import { jsx as _jsx } from "react/jsx-runtime";
import PageSection from '~components/page-section';
import { useEffect } from 'react';
import { logEvent } from '@phishtool/analytics';
import { MSSPProductComparison } from '@phishtool/products';
const MSSPPricingSection = ({ title, productContent }) => {
    useEffect(() => {
        logEvent('Pricing Viewed', { variant: 'mssp' });
    }, []);
    return (_jsx(PageSection, { id: "pricing", title: title, headerSpacer: ['x6', null, 'x9'], hasDivider: false, children: _jsx(MSSPProductComparison, { productContent: productContent }) }));
};
export default MSSPPricingSection;
